import { AxiosResponse } from 'axios'
import { api_simulacao_vendas } from 'services/apis'
import { Bem, BemToUpdate } from 'types/bem'
import {
  CarrinhoResumoResponse,
  CompartilharCarrinhoEmailParams,
  GetCarrinhoParams,
  ICarrinhoData,
  ICarrinhoResponse,
  ListarCarrinhosParams,
  SalvarNomeCarrinhoParams
} from 'types/carrinho'

export type CarrinhoListaItem = {
  cd_inscricao_nacional: string
  dh_inclusao: string
  nm_carrinho: string
  id_agrupamento_venda: number
  sn_flexibilizacao: 'S' | 'N'
  st_flex?: 'R' | 'L'
  st_status_flex_gestor?: 'P' | 'A' | 'R'
}

export type GetSavedCartParams = {
  id_agrupamento_venda: number | string
}

export type GetSavedCartResponse = {
  ds_guid: string
  consultarcarrinho: ICarrinhoData
  sn_mudanca: string
  cd_inscricao_nacional: string
}

export const getCarrinho = async ({ guid }: GetCarrinhoParams) => {
  const URL = `/simulador-venda/jornada/${guid}/carrinho`
  const response = await api_simulacao_vendas.get<ICarrinhoResponse>(URL)
  const data = response.data.data
  return data
}

export const getCarrinhoResumo = async ({ guid }: GetCarrinhoParams) => {
  const URL = `/simulador-venda/jornada/${guid}/carrinho/resumo`
  const response = await api_simulacao_vendas.get(URL)
  const data = response.data.data
  return data as CarrinhoResumoResponse
}

export const getSavedCart = async ({ id_agrupamento_venda }: GetSavedCartParams) => {
  try {
    const URL = `/simulador-venda/carrinho/${id_agrupamento_venda}`
    const response = await api_simulacao_vendas.get(URL)
    const data = response.data.data
    return data as GetSavedCartResponse
  } catch (error) {
    console.error('Failed to getCarrinhoById() service:', error)
    throw error
  }
}

export const postCarrinho = async ({ guid, bem }: { guid: string; bem: Partial<Bem> }) => {
  const URL = `/simulador-venda/jornada/${guid}/carrinho/bens`
  const response = await api_simulacao_vendas.post(URL, bem)
  const data = response.data.data
  return data
}

export const postCarrinhoUpdateTotal = async ({
  guid,
  bens
}: {
  guid: string
  bens: BemToUpdate[]
}) => {
  const URL = `/simulador-venda/jornada/${guid}/carrinho/todos/bens`
  const response = await api_simulacao_vendas.post(URL, bens)
  const data = response.data.data
  return data
}

export const postCompartilharCarrinhoEmail = async ({
  email,
  guid
}: CompartilharCarrinhoEmailParams) => {
  const URL = `/simulador-venda/jornada/${guid}/compartilhar-carrinho-email`
  const response = await api_simulacao_vendas.post(URL, {
    email
  })
  const data = response.data.data
  return data
}

export const putSalvarNomeCarrinho = async ({ nome_carrinho, guid }: SalvarNomeCarrinhoParams) => {
  try {
    const URL = `/simulador-venda/jornada/${guid}/salvar-nome-carrinho`
    const response = await api_simulacao_vendas.put(URL, {
      nm_carrinho: nome_carrinho
    })
    const data = response.data.data
    return data as AxiosResponse
  } catch (error) {
    console.error('Failed to postCarrinho() service:', error)
    throw error
  }
}

export const deleteSavedCart = async (guid: string) => {
  const URL = `/simulador-venda/jornada/${guid}/carrinho/completo`
  const response = await api_simulacao_vendas.delete(URL)
  return response
}

export const listarCarrinhos = async ({ car = '' }: ListarCarrinhosParams) => {
  try {
    const URL = '/simulador-venda/listar-carrinhos'
    const response = await api_simulacao_vendas.get(URL + `?nomeCarrinho=${car}`)
    const data = response.data.data
    return data as CarrinhoListaItem[]
  } catch (error) {
    console.error('Failed to listarCarrinhos() service:', error)
  }
}

export const deletarCarrinhoGrupo = async ({
  guid,
  id_grupo,
  id_bem
}: {
  guid: string
  id_grupo: number
  id_bem: number
}) => {
  try {
    const URL = `/simulador-venda/jornada/${guid}/carrinho/grupo/${id_grupo}/bens/${id_bem}`
    const response = await api_simulacao_vendas.delete(URL)
    const data = response.data.data
    return data
  } catch (error) {
    console.error('Failed to deletarCarrinhoGrupo() service:', error)
  }
}
